import { render } from "./ClinicConsentTemplateTab.vue?vue&type=template&id=46266404&scoped=true"
import script from "./ClinicConsentTemplateTab.vue?vue&type=script&lang=js"
export * from "./ClinicConsentTemplateTab.vue?vue&type=script&lang=js"

import "./ClinicConsentTemplateTab.vue?vue&type=style&index=0&id=46266404&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46266404"]])

export default __exports__